import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { zIndex } from '../../styles_js/variables';

export const BODY_OVERLAY_CLASS = `overlay-${Math.random()
  .toString(36)
  .substr(7)}`;

const getOverlayBgColor = ({ isTransparent, customOpacity = 0.3 }) => {
  return `rgba(0, 0, 0, ${isTransparent ? 0 : customOpacity})`;
};

export const BODY_OVERLAY_LOCK_CLASS = 'overlay-lock';

export const OverlaySt = styled.div`
  z-index: ${({ customZIndex }) => customZIndex || zIndex.overlay};
  display: ${props => (props.isShown ? 'block' : 'none')};
  background-color: ${getOverlayBgColor};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const updateBodyClass = (show, shouldLock = false) => {
  const bodyClasses = document.body.classList;

  if (show) {
    const classList = shouldLock
      ? [BODY_OVERLAY_CLASS, BODY_OVERLAY_LOCK_CLASS]
      : [BODY_OVERLAY_CLASS];
    bodyClasses.add(...classList);
  } else {
    bodyClasses.remove(BODY_OVERLAY_CLASS, BODY_OVERLAY_LOCK_CLASS);
  }
};

const handleUnmount = () => {
  updateBodyClass(false);
};

export const Overlay = props => {
  const {
    children,
    className,
    show,
    onClose,
    isTransparent,
    customZIndex,
    customOpacity,
  } = props;
  const shouldLock = show && !isTransparent;
  const ref = useRef(null);

  useEffect(() => {
    updateBodyClass(show, shouldLock);
    return handleUnmount;
  }, [show, isTransparent, shouldLock]);

  return (
    <OverlaySt
      ref={ref}
      className={className}
      isShown={show}
      isTransparent={isTransparent}
      onClick={onClose}
      onTouchEnd={onClose}
      customZIndex={customZIndex}
      customOpacity={customOpacity}
    >
      {children}
    </OverlaySt>
  );
};

Overlay.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  isTransparent: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  customZIndex: PropTypes.number,
  customOpacity: PropTypes.number,
};

Overlay.defaultProps = {
  children: null,
  className: '',
  isTransparent: false,
  onClose() {},
  customZIndex: zIndex.overlay,
  customOpacity: 0.3,
};
